import blocks from '../../assets/landing/blocks.svg';
import ruler from '../../assets/landing/ruler.svg';
import barChart from '../../assets/landing/bar-chart.svg';

// The four curriculum strands: the landing page's strand cards and the
// shared marketing footer's "Curriculum" column.
export const strands = [
  {
    icon: blocks,
    title: 'Number & Algebra',
    description:
      'Deep numeric comprehension, proportional reasoning, pattern-mapping and algebraic expression formulation.',
    years: [
      'Year 1',
      'Year 2',
      'Year 3',
      'Year 4',
      'Year 5',
      'Year 6',
      'Year 7',
      'Year 8',
    ],
  },
  {
    icon: ruler,
    title: 'Measurement & Space',
    description:
      'Geometric reasoning, spatial coordinate mapping, and structural dimension calculations.',
    years: [
      'Year 1',
      'Year 2',
      'Year 3',
      'Year 4',
      'Year 5',
      'Year 6',
      'Year 7',
      'Year 8',
    ],
  },
  {
    icon: barChart,
    title: 'Statistics & Probability',
    description:
      'Analytical data modelling, distribution evaluation, and predictive mathematical forecasting.',
    years: [
      'Year 1',
      'Year 2',
      'Year 3',
      'Year 4',
      'Year 5',
      'Year 6',
      'Year 7',
      'Year 8',
    ],
  },
];

// The six Australian Curriculum maths strands, for the footer's "Curriculum"
// column (owner 2026-10-04: three combined names read as if the product had
// only three topics). Names only, no skill counts: visitors see what is
// covered, then log in and explore the detail for their role.
export const curriculumStrands = [
  'Number',
  'Algebra',
  'Measurement',
  'Space',
  'Statistics',
  'Probability',
] as const;
